<template lang="pug">

  .week(
    :style="{paddingTop: padding}"
    :class="{clone: cloneMode, sticky}"
  )
    v-tabs(v-model="index" color="#fff" ref="tabs")
      v-tab(
        v-for="w, i in weeks"
        :key="i"
        ripple
        :class="{past: $moment(w).add(1, 'week').valueOf() < $store.getters.now.valueOf()}"
      ) {{ weekLabel(w) }}

    v-layout(
      column
      v-touch="{left: () => swipe(1), right: () => swipe(-1)}"
    )
      v-layout.header(:style="{paddingLeft: treeWidth+'px', top: sticky ? headerHeight+'px' : 0}" ref="weeks")
        v-icon.prev.mdi.mdi-chevron-left(:disabled="index <= 0"  @click="onPrevious")
        v-flex(
          v-for="day, i in weekdays"
          :key="i"
          :class="{holiday: !!day.holiday, today: isToday(day.timestamp)}"
          :style="styles"
        )
          | {{ day.timestamp | moment('ddd D.MM') }}
          span(v-if="day.holiday") {{ day.holiday.title }}
        v-icon.next.mdi.mdi-chevron-right(:disabled="index >= weeks.length - 1" @click="onNext")
      v-treeview(
        ref="tree"
        open-on-click
        :open.sync="openDepartments"
        :items="departments"
        item-key="treeId"
      )
        template(v-slot:label="{ item, open }")
          label.dept(v-if="item.model !== 'user'") {{ item.name }}
          v-layout(v-else)
            label.user(
              @click="toggleUser(item)"
              :class="{collapsed: isUserCollapsed(item)}"
            ): span: span
              v-avatar.mr-2(v-if="item.avatar" :size="isUserCollapsed(item) ? '20px' : '30px'")
                img(:src="item.avatar")
              //- v-icon(:small="isUserCollapsed(item)") {{ item.icon }}
              span {{ item.name }}
            v-layout(v-if="item.model == 'user'")
              v-flex.hours
                v-layout(column v-if="isUserCollapsed(item)")
                  v-flex.cell 0
                v-layout(column v-else)
                  v-flex.cell(v-for="hour, j in hours()" :key="j") {{ j + 1 }}
              v-flex.traffic(ref="table")
                v-flex.day(
                  v-for="day, j in weekdays" :key="j"
                  :class="{holiday: !!day.holiday, vacation: item.hasVacation(day.timestamp)}"
                  :style="styles"
                )
                  span(
                    v-if="!day.holiday && item.hasVacation(day.timestamp)"
                    :class="{collapsed: isUserCollapsed(item)}"
                  ) {{ $t('vacation.title') }}
                  user-day(v-if="!day.holiday && !item.hasVacation(day.timestamp)" :user="item" :day="day.timestamp" :collapsed="isUserCollapsed(item)" @edit="editTask")

    v-dialog(v-model="dialog" max-width="600px" persistent)
      task-form(v-if="task" :data="task" @close="editEnd")

</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import Department from '../store/models/Department'
import Task from '../store/models/Task'
import UserDay from '../components/traffic/UserDay'
import TaskForm from '../components/traffic/TaskForm'
import { getWeekLabel } from '../calendar'

export default {

  components: {
    UserDay,
    TaskForm,
  },

  data() {
    return {
      sticky: true,
      padding: 0,
      dialog: false,
      openDepartments: [],
      task: undefined,
      headerHeight: 0,
      treeWidth: 0,
      shift: undefined,
    }
  },

  computed: {
    ...mapGetters('auth', ['canEdit', 'settings']),
    ...mapGetters('entities/tasks', {
      newTask: 'newItem',
    }),
    ...mapGetters('traffic', [
      'cloneMode',
      'hours',
      'departments',
      'weeks',
      'weekdays',
    ]),
    index: {
      get() {
        return this.$store.getters['traffic/week_index']
      },
      set(index) {
        this.$router.push({
          name: this.$route.name,
          params: {
            ...this.$route.params,
            week: getWeekLabel(this.weeks[index])
          }
        })
      }
    },
    styles() {
      const styles = {}
      if(!isNaN(this.shift)) styles.transform = `translateX(calc(-${this.shift * 100}% - 1px))`
      return styles
    },
    table() {
      return Department.query().orderBy('name').get()
    },
    week() {
      return this.$route.params.week
    },
  },

  watch: {
    $route(to, from) {
      this.editTaskByRoute()
    },
    departments(departments) {
      this.$nextTick(() => this.openDepartments = this.settings.depts)
    },
    dialog(dialog) {
      if(!dialog) this.task = undefined
      this.$nextTick(() => document.scrollingElement.scrollTop = this._wasScrolled)
    },
    openDepartments(open, old) {
      let same = open.length == old.length
      if(same) {
        for(let i = 0; i < open.length; i++) {
          if(old.indexOf(open[i]) < 0) {
            same = false
            break
          }
        }
      }
      if(!same) this.setSettings({ depts: open })
    },
    task(task) {
      const params = {
        ...this.$route.params,
        task: task ? task.id : undefined
      }
      this.dialog = !!task
      if(this.$route.params.task == params.task) return
      this._wasScrolled = document.scrollingElement.scrollTop
      this.$router.push({
        name: this.$route.name,
        params
      })
    },
    week(week) {
      this.getWeek(week)
    },
    weekdays(weekdays) {
      this.onResize()
    },
  },

  beforeMount(){
    if(this.week) {
      this.getWeek(this.week)
    }
    else {
      this.$router.replace({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          week: getWeekLabel(this.$store.getters.now)
        }
      })
    }
    window.addEventListener('resize', this.onResize)
  },

  mounted() {
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('keydown', this.onKeyDown)
    window.addEventListener('keyup', this.onKeyUp)
    this.onScroll()
    if(this.$route.params.task) {
      setTimeout(this.editTaskByRoute.bind(this), 500)
    }
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('keydown', this.onKeyDown)
    window.removeEventListener('keyup', this.onKeyUp)
    window.removeEventListener('resize', this.onResize)
  },

  updated() {
    if(this.$refs.table) {
      this.headerHeight = document.querySelector('.v-application--wrap > * > .v-toolbar__content').offsetHeight
      this.treeWidth = this.$refs.table.offsetLeft + 4
    }
  },

  methods: {
    ...mapActions('auth', [
      'setSettings',
    ]),
    ...mapActions('entities/tasks', {
      getTask: 'getItem',
    }),
    ...mapActions('traffic', [
      'getTasks',
      'setCloneMode',
      'unshiftWeek',
    ]),

    editEnd(flush = false) {
      this.task = undefined
      // if(!flush) this.removeUnsavedTasks()
    },

    editTask(params) {
      this.task = params.data
    },

    editTaskByRoute() {
      const id = this.$route.params.task
      if(id) {
        const task = Task.find(this.$route.params.task)
        if(task) this.task = task
        if(!task) this.getTask(id).then(response => {
          // console.log('editTaskByRoute set task after getTask', id);
          this.task = Task.find(id)
        })
      }
    },

    getWeek(week) {
      const promise = this.$store.dispatch('traffic/getWeek', week)
      promise.then(result => {
        if(this.index == 0) this.unshiftWeek()
      })
      return promise
    },

    toggleUser(user) {
      const users = this.settings.users.slice()
      const index = users.indexOf(user.id)
      if(index >= 0) {
        users.splice(index, 1)
      }
      else users.push(user.id)
      this.setSettings({ users })
    },

    isMobile() {
      return window.matchMedia(`(max-width: 959px)`).matches
    },

    isToday(timestamp) {
      return moment(timestamp).isSame(moment(), 'day')
    },

    isUserCollapsed(user) {
      return this.settings.users.indexOf(user.id) >= 0
    },

    swipe(direction) {
      this.shift = Math.max(0, Math.min(4, this.shift + direction))
    },

    onKeyDown(e) {
      this.setCloneMode(e.altKey)
    },

    onKeyUp(e) {
      this.setCloneMode(e.altKey)
    },

    onNext() {
      if(this.isMobile()) this.swipe(1)
      else this.index++
    },

    onPrevious() {
      if(this.isMobile()) this.swipe(-1)
      else this.index--
    },

    onResize(e) {
      if(this.isMobile()) {
        for(let i = 0; i < this.weekdays.length; i++) {
          if(this.isToday(this.weekdays[i].timestamp)) {
            this.shift = i
            break
          }
        }
      } else this.shift = undefined
    },

    onScroll() {
      this.sticky = document.scrollingElement.scrollTop > this.$refs.tabs.$el.offsetHeight
      this.padding = this.sticky ? this.$refs.weeks.offsetHeight + 'px' : 0
    },

    weekLabel(week) {
      const start = moment(week)
      const end = start.clone().add(4, 'day')
      const one = start.month() == end.month()
      return `${start.format(one ? 'D' : 'D.MM')}-${end.format("D.MM (WW)")}`
    },
  }
}
</script>

<style lang="sass">
.week
  +elevation(5)
  .v-tab
    letter-spacing: initial
    padding: 0 12px
  .v-tabs__div.past
    opacity: .5

  .v-treeview
    min-height: 100vh
    // margin-bottom: 5px
    .v-treeview-node__root
      padding: 0
      height: auto
      min-height: 34px
      &, *
        cursor: initial

    .v-treeview-node__level
      width: 0

    > .v-treeview-node > .v-treeview-node__root
      border-top: 1px solid #000
      z-index: 1
      padding: 0.5em
      +elevation(5)
      .v-treeview-node__content
        &, *
          cursor: pointer

    .v-treeview-node--leaf
      margin: 0 !important
      padding: 0
      border-top: 1px solid #000
      margin-bottom: 2px
      &:before
        content: ''
        position: absolute
        left: 0
        right: 0
        border-top: 1px solid #000

    .v-treeview-node__label
      margin-left: 0
      overflow: visible
      .user
        &.collapsed
          font-size: .8em
        > span span
          display: flex
          align-items: center

      // .layout
      //   align-items: center
      //   &.user
      //     align-items: flex-start

    // .v-treeview-node__content
    //   align-items: end

  label.user
    width: 140px
    position: relative
    // overflow: hidden
    + .layout
      +elevation(3)
    > span
      position: absolute
      top: 50%
      transform: translateY(-50%)
    @media #{map-get($display-breakpoints, 'sm-and-down')}
      width: 30px
      > span
        transform: translateY(-12px)
      &.collapsed .v-avatar + span
        display: none
      &:not(.collapsed) > span
        font-size: 1rem
        transform: rotate(-90deg) translateY(-20px)
      > span, > span > span
        position: absolute
        top: 50%
        left: 50%
      > span > span
        display: flex
        // top: 50%
        // left: 0
        transform: translate(-55%, 3px)

  .header
    text-align: center
    padding-top: 0.5em
    padding-bottom: 0.5em
    // overflow: hidden
    .flex
      flex: 0 0 20%
      @media #{map-get($display-breakpoints, 'sm-and-down')}
        flex-basis: 100%
        // &:not(.current)
        //   display: none
        transition: all 300ms ease
      &:not(.holiday):not(.today)
        opacity: .5
      &.holiday
        color: red
        position: relative
        span
          pointer-events: none
          position: absolute
          bottom: -2.65em
          left: 0
          width: 100%
          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis
          z-index: 9
          @media #{map-get($display-breakpoints, 'sm-and-down')}
            display: none

  &.sticky
    // .v-tabs
    //   display: none
    .header
      border-bottom: 1px solid #000

  .header
    position: relative
    // overflow: hidden
    .v-icon
      width: 32px
      position: absolute
      z-index: 3
      &.prev
        left: 4px
      &.next
        right: 4px

  &.sticky .header
    position: fixed
    width: 100%
    z-index: 3
    .holiday span
      display: none

  .cell, .day.holiday, .day.vacation, .day .list > *
    position: relative
    &:before
      content: ''
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      border-left: 1px solid #000
      border-bottom: 1px solid #000
      z-index: 1
      background: none
      opacity: 1
    // &:last-of-type:before, &.day.holiday:before
    //   border-bottom-color: transparent

  .day.holiday:before
    background-color: rgba(red, .2)

  .day.vacation:not(.holiday)
    background-color: rgba(orange, .2)
    span
      opacity: .3
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      &.collapsed
        font-size: .8em

  .cell
    padding: 0.25em 1em
    width: 20%
    @media #{map-get($display-breakpoints, 'sm-and-down')}
      width: 100%

  &.clone .traffic .task
    &, *
      cursor: copy !important

  .hours
    font-size: 10px
    &, .layout, .cell
      width: auto
      flex-grow: 0
    .cell
      border-left-color: transparent
      opacity: .5
      &:last-of-type
        border-bottom: none



  .traffic
    display: flex
    position: relative
    overflow: hidden
    .day
      flex: 1 1 20%
      position: relative
      @media #{map-get($display-breakpoints, 'sm-and-down')}
        flex: 0 0 100%
        transition: all 300ms ease
        // &:not(.current)
        //   display: none
      .list
        display: flex
        flex-direction: column
        height: 100%
        &.collapsed
          flex-direction: row
        div[class^='task-'], div[class*=' task-']
          + div[class^='task-'], + div[class*=' task-']
            .task
              top: 1px
              height: calc(100% - 1px) !important
        .cell
          flex: 0 0 percentage(1/7)
          padding: 0
    .user
      height: 100%
    .task, .empty, .administration, .supervisor, .creative
      overflow: hidden
      flex-basis: percentage(1/7)
      z-index: 1

    .task, .administration, .supervisor, .creative
      .content
        position: absolute
        left: 10px
        right: 10px
        top: 8px
        bottom: 8px
        overflow: hidden
        line-height: 1.2
        .client
          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis
      &.done
        opacity: .5
      &.future
        opacity: .8
      @for $num from 2 through 8
        &.task-#{$num}
          // flex-basis: "calc(%s + 1px)" % (12.5% * num)
          flex-basis: percentage(1/7) * $num
      &.task-1, &.task-2, &.collapsed
        .content
          top: 2px
          bottom: 2px
      &.task-1, &.collapsed
        .content
          display: flex
          .client, .description
            font-size: .8em
          .description
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
      &.collapsed
        .content
          justify-content: space-between
          .client
            flex: 0 0 50%
          .description
            padding-left: .5em
        .owner, .icons
          display: none

    .list.draggable .task
      &, *
        cursor: move /* fallback if grab cursor is unsupported */
        cursor: -webkit-grab
        cursor: -moz-grab
        cursor: grab
    .task
      &.sortable-chosen
        &, *
          cursor: -webkit-grabbing
          cursor: -moz-grabbing
          cursor: grabbing
      &:before
        content: ''
        position: absolute
        width: 100%
        height: 100%
        z-index: 0
      .content .description
        font-size: .8em
      .owner
        position: absolute
        right: 0
        bottom: 0
        font-size: .75em
        padding: 0 .3em .15em
        opacity: .8
      .icons
        position: absolute
        right: 0
        .v-btn
          margin: 0
        .v-icon
          padding: 0
      &.task-1
        .content .description:before
          content: ''
          display: inline-block
          width: .5em
        .icons
          top: 50%
          transform: translateY(-50%)
          border-radius: 0

@mixin application($material)
  .week
    .header
      background-color: map-deep-get($material, 'bg-color')
    .v-treeview > .v-treeview-node > .v-treeview-node__root
      background-color: map-deep-get($material, 'cards')
    .hours .cell
      background-color: map-deep-get($material, 'cards')

    .traffic
      .owner
        background-color: map-deep-get($material, 'cards')
      .task
        &.task-1 .url
          background-color: map-deep-get($material, 'cards')
      .administration, .supervisor, .creative
        background-color: map-deep-get($material, 'text-color')
        color: map-deep-get($material, 'cards')

.v-application.theme--light
  +application($material-light)

.v-application.theme--dark
  +application($material-dark)
</style>